import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ProductConversion } from './product-conversion.entity';
import { ProductConversionController } from './product-conversion.controller';
import { ProductConversionService } from './product-conversion.service';
import { ProductConversionAdapter } from './dto/product-conversion.adapter';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
@Module({
  imports: [
    TypeOrmModule.forFeature([ProductConversion])
  ],
  controllers: [ProductConversionController],
  providers: [ProductConversionService,ProductConversionAdapter,ApplicationExceptionHandler,SaleOrderService]
})
export class ProductConversionModule {}
